import { render, staticRenderFns } from "./ScrollView.vue?vue&type=template&id=8551f7ba&scoped=true&"
import script from "./ScrollView.vue?vue&type=script&lang=js&"
export * from "./ScrollView.vue?vue&type=script&lang=js&"
import style0 from "./ScrollView.vue?vue&type=style&index=0&id=8551f7ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8551f7ba",
  null
  
)

export default component.exports